import {difference, union} from 'lodash'

/**
 * Vuex shared storageFilter/* mutations
 */
export const vuexStorageMutations = {
  replaceOnly(state, payload) {
    state.only = payload
  },
  addOnly(state, payload) {
    if(!state.only) {
      state.only = payload
      return
    }
    state.only = union(state.only, payload)
  },
  removeOnly(state, payload) {
    if(state.only) {
      state.only = difference(state.only, payload)
    }
  },
  replaceExcept(state, payload) {
    state.except = payload
  },
  addExcept(state, payload) {
    if(!state.except) {
      state.except = payload
      return
    }
    state.except = union(state.except, payload)
  },
  removeExcept(state, payload) {
    if(state.except) {
      state.except = difference(state.except, payload)
    }
  },
}
